import React from "react";
import { IconButton as MuiIconButton } from "@mui/material";
import { focusRingSx } from "../../../styles/focusRing";

// forwardRef so wrapping this in a Tooltip works (Tooltip needs the child's DOM ref to position/trigger on hover)
const IconButton = React.forwardRef(({ icon, sx, ...props }, ref) => (
  <MuiIconButton
    ref={ref}
    sx={{
      color: "#36355a",
      "&:hover": { backgroundColor: "#f5f5f5" },
      "&:focus-visible": focusRingSx,
      ...sx,
    }}
    {...props}
  >
    {icon}
  </MuiIconButton>
));


export default IconButton;
